
import { Vue, Component } from 'vue-property-decorator';
import InputFieldMock from '@/ui/components/devices/previews/components/InputFieldMock.vue';
import ShowEventDotMock from '@/ui/components/devices/previews/components/ShowEventDotMock.vue';
import SliderMock from '@/ui/components/devices/previews/components/SliderMock.vue';
import SwitchMock from '@/ui/components/devices/previews/components/SwitchMock.vue';
import DeviceLayout from '@/ui/components/devices/components/DeviceLayout.vue';

@Component({
  components: {
    InputFieldMock,
    ShowEventDotMock,
    SliderMock,
    SwitchMock,
    DeviceLayout,
  },
})
export default class ElectricChargingStationPreview extends Vue {
  get mainViewLang() {
    return 'devices.ElectricChargingStation.mainView';
  }
  get settingsViewLang() {
    return 'devices.ElectricChargingStation.settingsView';
  }
  get previewNameLang() {
    return this.$t('devices.ElectricChargingStation.previewName');
  }
}
